import React, { useContext as useContextCore } from 'react'
import { singProductQuery } from './graphql'
import type { UseDocumentResult } from '@ztechapps/common.hook'
import { useDocument } from '@ztechapps/common.hook'
import { useParams } from 'react-router-dom'
import type { Product } from '@ztechapps/common.contract'

export type ProviderProps = {
  children: React.ReactNode
}

export type Context = {
  quantity: number
  setQuantity: React.Dispatch<React.SetStateAction<number>>
} & Omit<ProviderProps, 'children'> &
  UseDocumentResult<Product>

const context = React.createContext<Context>({} as Context)
const CoreProvider = context.Provider

export const Provider = ({ children, ...props }: ProviderProps) => {
  let { _id } = useParams()
  _id = decodeURIComponent(_id)
  const [quantity, setQuantity] = React.useState(1)

  const documentResult = useDocument<Product>({ query: singProductQuery, _id })

  return <CoreProvider value={{ ...props, ...documentResult, quantity, setQuantity }}>{children}</CoreProvider>
}

export const useContext = () => useContextCore(context)
